import { IonPage, IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent, IonRow, IonCol } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React from 'react';
import Webix from '../components/Webix';

const Dashboard: React.FC<any> = () => {
    const ui = {
        view:"reports", 
        url: process.env.REACT_APP_REPORTS_ENDPOINT,
        width: "500",
        height: "500",
        readonly: true,
        toolbar: false,
        moduleId: 3,
        mode: "view"
    };

    const ui2 = {
        view:"reports", 
        url: process.env.REACT_APP_REPORTS_ENDPOINT,
        width: "500",
        height: "500",
        readonly: true,
        toolbar: false,
        moduleId: 4,
        mode: "view"
    };

    const ui3 = {
        view:"reports", 
        url: process.env.REACT_APP_REPORTS_ENDPOINT,
        width: "1050",
        height: "500",
        readonly: true,
        toolbar: false,
        moduleId: 7,
        mode: "view"
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="secondary">
                        <IonBackButton icon={arrowBack} text="" className="custom-back" />
                    </IonButtons>
                    <IonTitle>Dashboard</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <IonRow>
                    <IonCol style={{padding: '0 20px'}}>
                        <h4 style={{textAlign: 'center'}}>New Accounts By Week</h4>
                        <Webix ui={ui} />
                    </IonCol>
                    <IonCol style={{padding: '0 20px'}}>
                        <h4 style={{textAlign: 'center'}}>Enrollments By Groups</h4>
                        <Webix ui={ui2} />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol style={{padding: '0 20px'}}>
                        <h4 style={{textAlign: 'center'}}>Enrollments Since Wk 19</h4>
                        <Webix ui={ui3} />
                    </IonCol>
                </IonRow>
            </IonContent>
        </IonPage>
    );
};

export default Dashboard;